/**
 * Component responsible for populating the content for creditChanges tab inside details drawer.
 */

import React, { Suspense, useEffect, useState } from 'react';


interface IProps {
    timeLimit: number;
    setTimesUp: any;
}

const CountDownTimer: React.FC<IProps> = ({
    timeLimit,
    setTimesUp,

}: IProps) => {
    const FULL_DASH_ARRAY = 283;
    const WARNING_THRESHOLD = timeLimit/2;
    const ALERT_THRESHOLD = timeLimit/4;
    const COLOR_CODES = {
        info: {
            color: "green"
        },
        warning: {
            color: "orange",
            threshold: WARNING_THRESHOLD
        },
        alert: {
            color: "red",
            threshold: ALERT_THRESHOLD
        }
    };

    let timePassed = 0;
    let timeLeft = timeLimit;

    const reset = () => {
        timeLeft = timeLimit;
        timePassed = 0;
    }

    React.useEffect(() => {
        const timerId = setInterval(() => startTimer(), 1000);

        return () => clearInterval(timerId);
    });

    const startTimer = () => {
        timePassed = timePassed += 1;
        timeLeft = timeLimit - timePassed;

        document.getElementById("base-timer-label")!.innerHTML = formatTime(
            timeLeft
        );
        setCircleDasharray();
        setRemainingPathColor(timeLeft);

        if (timeLeft === 0) {
            setTimesUp(true)
            reset()
        }
    }
    
    const formatTime = (time: number) => {
        const minutes = Math.floor(time / 60);
        let seconds = time % 60;

        if (seconds < 10) {
            seconds = seconds;
        }

        return `${seconds}`;
    }

    const setRemainingPathColor = (timeLeft: number) => {
        const { alert, warning, info } = COLOR_CODES;
        if (timeLeft <= alert.threshold) {
            document
                .getElementById("base-timer-path-remaining")!
                .classList.remove(warning.color);
            document
                .getElementById("base-timer-path-remaining")!
                .classList.add(alert.color);
        } else if (timeLeft <= warning.threshold) {
            document
                .getElementById("base-timer-path-remaining")!
                .classList.remove(info.color);
            document
                .getElementById("base-timer-path-remaining")!
                .classList.add(warning.color);
        }
    }

    const calculateTimeFraction = () => {
        const rawTimeFraction = timeLeft / timeLimit;
        return rawTimeFraction - (1 / timeLimit) * (1 - rawTimeFraction);
    }

    const setCircleDasharray = () => {
        const circleDasharray = `${(
            calculateTimeFraction() * FULL_DASH_ARRAY
        ).toFixed(0)} 283`;
        document
            .getElementById("base-timer-path-remaining")!
            .setAttribute("stroke-dasharray", circleDasharray);
    }

    return (
        <div className="base-timer">
            <svg className="base-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <g className="base-timer__circle">
                    <circle className="base-timer__path-elapsed" cx="50" cy="50" r="45"></circle>
                    <path
                        id="base-timer-path-remaining"
                        className="base-timer__path-remaining green"
                        d="
          M 50, 50
          m -45, 0
          a 45,45 0 1,0 90,0
          a 45,45 0 1,0 -90,0
        "
                    ></path>
                </g>
            </svg>
            <span id="base-timer-label" className="base-timer__label">{timeLimit}</span>
        </div>
    );
};

export default CountDownTimer;
